import { CssType, ThemeType } from 'src/theme/jss-types';
import {
  getSelectStyleForSelectWithInput,
  getTextInputStyleForSelectWithInput,
  refreshButton,
} from 'src/theme/cssSnippets/commonSnippets';
import { MIN_WIDTH, MOBILE_BREAK_POINT } from 'src/globals';

export const DeliveryRequestStyles = (theme: ThemeType): CssType => ({
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '& .ant-checkbox-inner': {
      width: '15px',
      height: '15px',
    },
    '& .anticon-down': {
      fontSize: '12px',
    },
    '& .ant-btn ant-dropdown-trigger': {
      borderColor: theme.primaryColor,
      color: theme.primaryColor,
    },
    minWidth: MIN_WIDTH,
  },
  bodyDiv: {
    backgroundColor: '#eee',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  searchContainer: {
    background: '#FFF',
    padding: '14px 16px',
    borderRadius: '4px',
    width: 'fit-content',
    border: '1px solid #d9d9d9',
  },
  searchStyle: {
    ...getTextInputStyleForSelectWithInput(),
    minWidth: '250px',
    maxWidth: '300px',
    '& .ant-input': {
      borderRadius: '4px',
    },
  },
  row: {
    margin: '16px 0 16px 0 !important',
    borderRadius: '4px',
    border: '1px solid #d9d9d9',
    background: '#FFF',
    padding: '20px 16px',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  colLabel: {
    color: '#595959',
    fontSize: '12px',
    lineHeight: '17px',
  },
  colValue: {
    marginTop: '13px',
    color: '#262626',
    fontSize: '14px',
    lineHeight: '19px',
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  tableContainer: {
    borderRadius: '4px',
    border: '1px solid #d9d9d9',
    background: '#FFF',
    marginTop: '16px',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: '19px 17px',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  table: {
    margin: 0,
    '& .ant-table-pagination.ant-pagination': {
      margin: '-60px 24px 16px',
    },
    '& .ant-table-tbody > tr > td': {
      wordWrap: 'break-word',
      wordBreak: 'break-all',
      '& a': {
        color: '#1659CB',
      },
    },
    '& .ant-table-thead': {
      color: '#333333',
    },
    '& .ant-table-thead > tr > th': {
      wordBreak: 'break-word',
      backgroundColor: '#F2F7FC',
      color: '#333333',
      overflow: 'hidden',
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: '12px',
      padding: '16px',
      borderRight: '0.5px solid #DDD',
      '& .ant-table-column-title': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '100%',
      },
    },
    '& .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before': {
      backgroundColor: 'unset',
    },
    '& .ant-table-row > td': {
      fontSize: '12px',
      lineHeight: '14px',
      padding: '10px 12px',
      color: '#333333',
      fontWeight: '500',
      borderRight: '0.5px solid #DDD',
    },
    '& .ant-table-row-selected > td': {
      backgroundColor: `#E6F7FB !important`, // Solid color without opacity to prevent stacking issues with fixed columns
    },
  },
  selectWithoutBorder: {
    margin: '0 5px',
  },
  btn: {
    color: 'blue',
    cursor: 'default',
  },
  actionsDiv: {
    padding: '4px 12px',
    border: '1px solid #111111',
    cursor: 'pointer',
    color: '#111111',
    textAlign: 'center',
    borderRadius: '4px',
    width: '24px',
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      border: '1px solid #1659CB',
      cursor: 'pointer',
      color: '#1659CB',
    },
  },
  carouselWrapper: {
    '& .ant-carousel .slick-slider .slick-prev': {
      color: 'black;',
      fontSize: '20px;',
      marginLeft: '5px',
    },
    '& .ant-carousel .slick-slider .slick-next': {
      color: 'black;',
      fontSize: '20px;',
      marginRight: '5px ',
    },
    '& .ant-carousel .slick-slider .slick-dots li button, & .ant-carousel .slick-slider .slick-dots li.slick-active button': {
      backgroundColor: '#333 !important',
    },
  },
});
